"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const client = require("@prismicio/client");
const isReleasePreview = require("./isReleasePreview.cjs");
const fetchNewDocuments = async ({ client: client$1, abortController }) => {
  const signal = abortController.signal;
  const first = await client$1.getFirst({ signal });
  if (isReleasePreview.isReleasePreview()) {
    const rest = await client$1.dangerouslyGetAll({
      predicates: [
        client.filter.dateBetween("document.last_publication_date", Date.parse(first.last_publication_date), Date.parse(first.last_publication_date) + 1e3),
        client.filter.not("document.id", first.id)
      ],
      signal
    });
    return [first, ...rest];
  } else {
    return [first];
  }
};
exports.fetchNewDocuments = fetchNewDocuments;
//# sourceMappingURL=fetchNewDocuments.cjs.map
